<ion-content>
  <div class="scroll-content-modal padding-s">
    <app-header-modal
      [title]="'loginModal.title' | t"
      [showToggle]="false"
      [showClose]="true"
      (close)="onCancel()">
    </app-header-modal>

    <app-login 
      [introMessage]="'loginModal.message' | t"
      (loginSuccess)="onLoginSuccess()"
      (signupClick)="onSignupClick()">
    </app-login>
  </div>
</ion-content>
